import { render, staticRenderFns } from "./OtherIncomeSetup.vue?vue&type=template&id=2a0e90c4&"
import script from "./OtherIncomeSetup.vue?vue&type=script&lang=js&"
export * from "./OtherIncomeSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports